export default "/images/recruit-best.webp?650423866fbdbe25eb69e92e490dce13";